import { StringFilterDropdown } from "@/entities/string-filter-dropdown";
import { DEFAULT_NOTE_TYPES, NOTE_STATUS } from "@/services/api";
import { PersonTitle } from "@/common/PersonTitle";
import type { NotesTableColumnGetter, NotesTableColumnsProps } from "../types";
import type { NotesTableRowData } from "../types/notes-table-types";
import { NOTES_TABLE_COLUMNS_KEYS } from "../notes-table-columns-keys";
import { getRowTextColor } from "../../lib/get-row-text-color";

export type NotesTablePersonTitleColumnProps = NotesTableColumnsProps<{
  colorize?: boolean;
  onChangeFilter?: (value: string) => void;
  filterValue?: string;
}>;

export type NotesTablePersonTitleColumnGetter =
  NotesTableColumnGetter<NotesTablePersonTitleColumnProps>;

export const getNotesTablePersonTitleColumn: NotesTablePersonTitleColumnGetter = ({
  title = "Title",
  dataIndex = ["person.title"],
  width = 173,
  key = NOTES_TABLE_COLUMNS_KEYS.title,
  colorize = false,
  sorter = (a: NotesTableRowData, b: NotesTableRowData) =>
    typeof a?.person?.title === "string"
      ? (a?.person?.title as string).localeCompare(b?.person?.title as string)
      : -1,
  showSorterTooltip = false,
  onChangeFilter = () => "",
  filterValue,
  filterDropdown,
  render = (_, record) => (
    <PersonTitle
      textColor={getRowTextColor(
        record,
        colorize && DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT === record.noteType.name,
      )}
      title={record?.person?.title ?? ""}
      disabled={
        record.status === NOTE_STATUS.DONE &&
        record.noteType.name === DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT
      }
    />
  ),
  ...props
}) => {
  const defaultFilterDropdown = (
    <StringFilterDropdown
      handleChange={(value) => onChangeFilter(value ?? "")}
      value={filterValue ?? ""}
    />
  );
  return {
    title: title,
    dataIndex: dataIndex,
    width: width,
    key: key,
    sorter: sorter,
    filterDropdown: filterDropdown ? filterDropdown : defaultFilterDropdown,
    render: render,
    showSorterTooltip: showSorterTooltip,
    ...props,
  };
};
